export default () => (dispatch, getState) => {

  const { token, wtRegion, entry }  = getState()

  const nameToYears = name => {

    switch(name){
      case 'US Corp. Bond Yield Spread':
        return 7;
      case 'rFree':
        return 0;
      case 'rFreeDaily':
        return 0;
      default:
        return parseInt(name.match(/[0-9]/g).join(""),10)*(name.match("Day") ? (1/365) : 1);
    } 

  }
    
  const makeTheCall = (url, callback) => {
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token &&
          `Token ${token}`,
      }
    })
    .then(d => d.json())
    .then(callback)
    .catch(error => {
      console.error(error);
    })
  }

  makeTheCall(
    `${process.env.REACT_APP_API_URL}/stresstest/model/all/?wtRegion=${wtRegion}&entityCCY=${entry.original.entityCCY}`, 
    data => { 
      dispatch({ type: 'LOAD_PERMANENT_STRESS_TESTS', tests: data })
    }
  )

  makeTheCall(`${process.env.REACT_APP_API_URL}/riskfreemap/geocentric/?wtRegion=${wtRegion}&entityCCY=${entry.original.entityCCY}`, data => {
    try{
      const rates = data
      .reduce((t, { name, riskFreeRates, riskFreeDates, globalKey }) => ({
        ...t,
        [globalKey]: {
          rate: riskFreeRates[riskFreeRates.length - 1],
          date: riskFreeDates[riskFreeDates.length - 1],
          yrsToMaturity: nameToYears(name),
          name
        }
      }), {})
    dispatch({ type: 'LOAD_RISK_FREE_RATES', rates })
    } catch (error) {
      console.log(error);
    }
  })

};


// WEBPACK FOOTER //
// ./src/actions/query-api/stress-test-data.js